import React, { useEffect, useState, forwardRef, useMemo, useRef } from 'react';
import FunnelChartComponent from '../funnelchart/funnelchart';
import Subscription from '../subscription/subscription';
import DoughnutChart from '../doughnutchart/doughnut';
import PieChart from '../piechart/piechart';
import { Container, Row, Col } from 'react-bootstrap';
import { ReactComponent as IndiaMap } from './IndiaMap.svg';
import './dashboardcontent.css';
import Trending from '../../../../assets/images/trending.png';
import client_notice_img from '../../../../assets/images/notice_image.png';
import client_time_icon from '../../../../assets/images/time_icon.png';
import ClientRecentFilter from '../../../../assets/images/Ic_filter.png';
import ClientSortRecentFilter from '../../../../assets/images/Ic_sort.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ClientService } from '../../../../services/clientService';
import { decodeJWT } from '../../../../services/candidateService';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import { serverConfig } from '../../../../services/server-config';
import { CandidateService } from '../../../../services/candidateService';
import default_profile_image from '../../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { roundDataValues } from './dataUtils';
import { useLocation, useNavigate } from 'react-router-dom';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Article2Image from '../../../../assets/images/Card-No-1.jpeg';
import Article3Image from '../../../../assets/images/Card No 5.png';
import Article4Image from '../../../../assets/images/profile.jpg';
import Article5Image from '../../../../assets/images/Card-No-4.jpeg';
import Article6Image from '../../../../assets/images/Card-No-2.jpeg';
import Article7Image from '../../../../assets/images/Card-No-6.jpeg';
import Article8Image from '../../../../assets/images/Card-No-7.jpeg';
import ArticleImage2 from '../../../../assets/images/Card No 8.png';
import ArticleImage3 from '../../../../assets/images/About_Us.jpeg';
import ArticleImage4 from '../../../../assets/images/blog_detail_2.jpg';
import { Link } from 'react-router-dom';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <div className="client-custom-input" onClick={onClick} ref={ref}>
    {value && value !== "Invalid Date" ? value : "Select Month"}
    <FontAwesomeIcon icon={faCalendarAlt} className="client-calendar-icon" />
  </div>
));

function generateContrastingColors(count) {
  const baseColors = ["#F57141", "#4DB5D9", "#9EDB6B", "#694FD6"];
  const baseHSL = baseColors.map(hexToHSL);

  const colors = [];
  for (let i = 0; i < count; i++) {
    const baseIndex = i % baseHSL.length;
    const [h, s, l] = baseHSL[baseIndex];

    const newLightness = Math.min(80, l + (i * 5) % 30);
    const newSaturation = Math.max(50, s - (i * 5) % 20);

    colors.push(`hsl(${h}, ${newSaturation}%, ${newLightness}%)`);
  }
  return colors;
}

function hexToHSL(hex) {
  let r = parseInt(hex.substring(1, 3), 16) / 255;
  let g = parseInt(hex.substring(3, 5), 16) / 255;
  let b = parseInt(hex.substring(5, 7), 16) / 255;

  let max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    let d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h = Math.round(h * 60);
  }
  return [h, Math.round(s * 100), Math.round(l * 100)];
}


const fetchData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        recentClients: [
          // { designation: 'Director', industry: 'Pharmaceuticals', ctc: '36L / annum' },
          // { designation: 'CEO', industry: 'Chemical', ctc: '68L / annum' },
          // { designation: 'CFO', industry: 'Textile', ctc: '50L / annum' },
        ],
        notices: [
          {
            title: 'Cursus quam vel odio',
            time: '30 mins Ago',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
          },
          {
            title: 'Cursus quam vel odio',
            time: '30 mins Ago',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Est eu egestas augue sem habitasse elit, mauris mattis massa. Sollicitudin lacus rhoncus.',
          },
        ],
        locationData: {
          delhi: 36,
          mumbai: 80,
          hyderabad: 43,
        },
      });
    }, 1000);
  });
};

const DashboardContent = ({ dashboardData, selectedDate, onDateChange, shortlistAnalytics, isDateSelected }) => {
  const location = useLocation();

  const restoredState = useRef(null);

  if (restoredState.current === null) {
    const cached = sessionStorage.getItem('dashboard_shortlist_state');
    restoredState.current = cached ? JSON.parse(cached) : undefined;
  }

  const decoded = decodeJWT(window.localStorage.getItem('authToken'));
  const clientId = _.get(decoded, 'clientId', '');
  const [shortlistedCandidates, setShortlistedCandidates] = useState(
    restoredState.current?.shortlistedCandidates || []
  );

  const [page, setPage] = useState(
    restoredState.current?.page ?? 0
  );

  const [hasNext, setHasNext] = useState(
    restoredState.current?.hasNext ?? false
  );

  const [totalPages, setTotalPages] = useState(
    restoredState.current?.totalPages ?? 1
  );


  const [size] = useState(10);

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [imageUrls, setImageUrls] = useState([]);
  const [recentClients, setRecentClients] = useState([]);
  const [shortlistedClients, setShortlistedClients] = useState([]);
  const [notices, setNotices] = useState([]);
  const workTypeData = {};
  const navigate = useNavigate();
  const [isShortlistLoading, setIsShortlistLoading] = useState(false);
  const [isRecentSearchLoading, setIsRecentSearchLoading] = useState(false);
  useEffect(() => {
    if (location.state?.from === 'dashboard') {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: location.state.scrollY || 0,
          behavior: 'auto',
        });
      });
    }
  }, []);



  const articles = [
    {
      id: 1,
      title: 'Navigating Career Changes at the Executive Level: Transitioning Roles, Industries, and More',
      date: '26 Feb, 2025',
      readTime: '5 Min Read',
      image: Article3Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>Navigating Career Changes at the Executive Level: Transitioning Roles, Industries, and More</h2>

<p>Career transitions are often seen as opportunities for growth and new challenges, and nowhere is this truer than at the executive level. Shifting from one industry to another while holding a top-level position can be a transformative experience filled with unique challenges and exciting opportunities. In this blog post, we'll explore the intricacies of navigating such transitions, highlighting the key factors that executives should consider when embarking on a career change between domains.</p>
<h3>1. The Art of Skill Translation:</h3>
<p>One of the initial challenges executives face when transitioning between industries is translating their existing skills and expertise. Discover how to identify transferable skills and apply them effectively in your new industry.</p>
<h3>2. Embracing a Learning Mindset:</h3>
<p>Transitioning to a new industry often means stepping into unfamiliar territory. Unlearning outdated knowledge and adopting a learning mindset are essential for success. Seek opportunities for professional development and education to stay ahead of the curve and develop the skills and expertise you need to thrive in your new role.</p>
<h3>3. Leveraging Your Network:</h3>
<p>Your professional network can be a valuable asset during industry transitions. Learn how to tap into your connections, seek advice, and make new industry-specific contacts.</p>
<h3>4. Navigating Industry-Specific Challenges:</h3>
<p>Different industries come with their own set of challenges and regulations. Delve into strategies for understanding and addressing these unique industry-specific hurdles.</p>
<h3>5. Establishing Credibility:</h3>
<p>Building trust and credibility in a new industry is vital. Discover ways to showcase your expertise and make a compelling case for why you are an asset in your new executive role.</p>
<h3>6. Balancing Industry Experience and Fresh Perspective:</h3>
<p>Executives often bring a fresh perspective when transitioning industries, but they must also respect existing industry norms. Explore the art of balancing your valuable insights with industry traditions.</p>
<h3>7. Cultivating Resilience:</h3>
<p>Career transitions, especially at the executive level, can be demanding. Uncover techniques for cultivating resilience and managing the inevitable challenges that arise during industry shifts.</p>
<h3>8. Measuring Success:</h3>
<p>Determine how to set meaningful goals and key performance indicators (KPIs) to track your success in the new industry.</p>
<h2>Embracing Change at the Executive Level</h2>
<p>Transitioning domains at the executive level is a journey that requires a mix of courage, adaptability, and strategic planning. While it may come with challenges, it also presents exciting opportunities for personal and professional growth. Embrace change, be open to learning, and leverage your existing skills to embark on a successful career transition between fields. Remember that your experience and leadership can be invaluable assets in your new role.</p>
<p>In this ever-evolving professional landscape, career transitions are becoming more common, and they offer executives a chance to explore new horizons, make a lasting impact, and redefine their professional narratives. Whether you're contemplating a domain switch or already in the midst of one, embracing change at the executive level can lead to a rewarding and fulfilling career journey.</p>

`,

    },
    {
      id: 2,
      title: 'Looking Beyond Women For Diversity and Inclusion: Why It\'s Important?',
      date: '19 Feb, 2025',
      readTime: '5 Min Read',
      image: Article8Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>Looking Beyond Women For Diversity and Inclusion: Why It's Important?</h2>
<p>Diversity and inclusion (D&I) in the workplace have become a top priority for many organizations in recent years. However, many people still focus only on gender diversity when thinking about D&I, which can lead to overlooking other important dimensions of diversity, such as race, ethnicity, sexual orientation, disability, and socioeconomic status.</p>
<h3>Why is it important to look beyond women for D&I?</h3>
<p>There are several reasons why it is important to look beyond women for D&I. First, women are not a monolithic group. They have different experiences, perspectives, and backgrounds, just like everyone else. Second, there are many other groups of people who are also underrepresented in the workplace and deserve to be included. Third, a truly diverse and inclusive workplace is one where everyone feels welcome and valued, regardless of their background or identity.<p>
<h3>How can we look beyond women for D&I?</h3>
<p>Here are a few tips for looking beyond women for D&I:</p>
<ul>
  <li>Expand Your Definition of Diversity. Diversity is about more than just gender. It also includes race, ethnicity, sexual orientation, disability, socioeconomic status, and other dimensions of identity.</li><br>
  <li>Be Intentional About Your Hiring and Promotion Practices. Make sure that you are actively recruiting and promoting people from all different backgrounds.</li><br>
  <li>Create a Culture of Inclusion. Everyone deserves to feel welcome and valued in the workplace. Create a culture where everyone feels comfortable sharing their ideas and perspectives.</li>
</ul>

<h3>What are the benefits of looking beyond just women for D&I?</h3>
<p>There are many benefits to looking beyond just women for D&I. A diverse and inclusive workplace is more innovative, more productive, and more profitable. It is also a more attractive place to work for top talent.</p>
<p>Facts:</p>
<ul>
  <li>A study by McKinsey & Company found that companies with more diverse leadership teams are more likely to outperform their peers financially.</li><br>
  <li>A study by Glassdoor found that companies with high D&I ratings are more likely to be seen as attractive employers.</li><br>
  <li>A study by the Boston Consulting Group found that companies with high D&I ratings are more likely to have innovation cultures.</li>
</ul>

<h3>Future trends in D&I</h3>
<p>In 2023 and beyond, we can expect to see a continued focus on D&I in the workplace. Organizations will be increasingly focused on creating cultures where everyone feels welcome and valued, regardless of their background or identity. We will also see a shift towards a more intersectional approach to D&I, which means recognizing the interconnectedness of different dimensions of identity, such as race, gender, and sexual orientation.</p>
<p>Here are some specific trends that we can expect to see in D&I in the future:</p>
<ul>
  <li>A focus on neurodiversity and disability inclusion.</li>
  <li>A greater emphasis on mental health and well-being.</li>
  <li>A more inclusive approach to parental leave and other family-friendly policies.</li>
  <li>A shift towards remote and hybrid work arrangements can make it easier for people from all backgrounds to participate in the workforce.</li>
</ul>

<p>Looking beyond women for D&I is essential for creating a truly diverse and inclusive workplace. By expanding our definition of diversity, being intentional about our hiring and promotion practices, and creating a culture of inclusion, we can reap the many benefits of a diverse workforce.</p>
<p><strong>Sources:</strong></p>
<ul>
  <li>McKinsey & Company, "Diversity wins: How inclusion matters"</li>
  <li>Glassdoor, "2023 Employee Choice Awards: Best Places to Work"</li>
  <li>Boston Consulting Group, "Diversity Wins: How Inclusion and Diversity Accelerate Innovation"</li>
</ul>

`    ,

    },
    {
      id: 3,
      title: 'Bosses and workers disagree on return to office: How to bridge the gap?',
      date: '12 Feb, 2025',
      readTime: '5 Min Read',
      image: Article2Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>Bosses and workers disagree on return to office: How to bridge the gap?</h2>
<p>The COVID-19 pandemic has forced many companies to rethink their workplace policies, including remote work. While some companies have embraced remote work wholeheartedly, others are eager to return to the office full-time.</p>
<p>However, there is a disconnect between bosses and workers on the issue of return to office. A recent study found that 76% of mid- and entry-level professionals remain hesitant to work in a shared environment on a full-time basis. Only 17% of work-from-home employees hope to work in their corporate office every day.</p>
<h3>This divergence in opinion can be attributed to several factors, including:</h3>
<ul>
  <li><strong>Different Job Roles:</strong> Executives and non-executive employees often have different job roles and responsibilities. Executives are more likely to meet with clients in person or to collaborate with other executives in the office, whereas non-executive employees are more likely to be able to effectively perform their jobs remotely.</li><br>
  <li><strong>Different Work Preferences:</strong> Some people simply prefer to work in an office setting, while others prefer to work from home. There are many reasons for this, such as personal productivity, work-life balance, and commute time.</li><br>
  <li><strong>Different Levels of Job Satisfaction:</strong> A recent study found that executives' overall satisfaction level increased amid the shift to a physical work environment, while non-executives saw their satisfaction level decrease. This may be because executives have more control over their work environment and schedule.</li>
</ul>

<h3>How to bridge the gap?</h3>
<p>Companies can bridge the gap between bosses and workers on the issue of return to office by:</p>
<ul>
  <li><strong>Embracing Flexibility:</strong> Companies should offer employees a variety of work arrangements, such as full-time remote work, hybrid work, and flexible work hours. This will give employees the flexibility to choose the work arrangement that best suits their needs.</li><br>
  <li><strong>Training and Rewarding Inclusion:</strong> Companies should train managers and employees on how to create and maintain an inclusive workplace culture. This includes providing training on topics such as unconscious bias and remote work etiquette. Companies should also reward employees for their contributions to the team, regardless of where they work from.</li><br>
  <li><strong>Building Connection Through Transparency:</strong> Companies should be transparent with employees about their return-to-office plans. This includes communicating the company's goals for returning to the office, as well as the steps that will be taken to protect employee health and safety. Companies should also provide employees with opportunities to give feedback on the company's return-to-office plans.</li>
</ul>

<p>By taking these steps, companies can create a workplace that is flexible, inclusive, and supportive of all employees, regardless of their job roles, work preferences, or location.</p>
<p>The issue of return to office is a complex one, but it is important that companies listen to their employees and find a solution that works for everyone. By embracing flexibility, training and rewarding inclusion, and building connection through transparency, companies can bridge the gap between bosses and workers on this issue.</p>
 <p><strong>Sources -</p></strong></p>
      <p><a href="https://www.peoplematters.in/news/culture/bosses-workers-dont-see-eye-to-eye-on-return-to-office-31356"
      target="_blank" rel="noopener noreferrer">
      https://www.peoplematters.in/news/culture/bosses-workers-dont-see-eye-to-eye-on-return-to-office-31356
      </a>`,

    },
    {
      id: 4,
      title: 'The Unwavering Importance of Employee Engagement: A Call to Action for Business Leaders',
      date: '5 Feb, 2025',
      readTime: '5 Min Read',
      image: Article6Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>The Unwavering Importance of Employee Engagement: A Call to Action for Business Leaders</h2>
<p>In the dynamic realm of business, where success hinges on the collective efforts of individuals, employee engagement stands as a beacon of organizational vitality. It's the lifeblood that courses through the veins of a company, fueling innovation, productivity, and ultimately, sustainable growth. To neglect the importance of employee engagement is to risk anaemia in the workplace, leading to stagnation, decline, and potential demise.</p>
<p>Employee engagement is not merely a buzzword or a fleeting trend; it's a profound and multifaceted concept that encompasses the emotional, intellectual, and behavioural connection an employee feels towards their work and their organization. It's the difference between an employee who merely shows up and one who wholeheartedly invests their energy, creativity, and passion.</p>
<p>The benefits of a highly engaged workforce extend far beyond improved morale and reduced turnover. Studies have consistently shown that engaged employees are more productive, innovative, and customer-centric, leading to enhanced financial performance and a stronger competitive edge.</p>
<p>Yet, despite the overwhelming evidence of its benefits, employee engagement remains a critical challenge for many organizations. The fast-paced, demanding nature of modern work, coupled with the increasing prevalence of remote work arrangements, has created a fertile ground for disengagement and burnout.</p>
<p>The onus, therefore, falls upon business leaders to foster a culture of engagement, one that nurtures the intrinsic motivation and well-being of their employees. This requires a holistic approach that encompasses a variety of strategies, from fostering open communication and providing opportunities for growth to recognizing achievements and promoting a sense of purpose.</p>
<h3>Here are a few key steps business leaders can take to cultivate a culture of employee engagement:</h3>
<ol>
  <li><strong>Prioritize Open and Honest Communication:</strong> Encourage open dialogue between employees and management, creating a safe space for feedback and suggestions.</li><br>
  <li><strong>Empower Employees with Autonomy and Ownership:</strong> Provide employees with the freedom to make decisions and take ownership of their work.</li><br>
  <li><strong>Recognize and Reward Achievements:</strong> Celebrate successes, both big and small, to reinforce positive behavior and boost morale.</li><br>
  <li><strong>Invest in Employee Development and Training:</strong> Offer opportunities for continuous learning and skill enhancement, demonstrating a commitment to employee growth.</li><br>
  <li><strong>Foster a Sense of Purpose and Belonging:</strong> Communicate the organization's mission and values, aligning individual contributions to a larger collective impact.</li><br>
  <li><strong>Promote Work-Life Balance:</strong> Encourage a healthy balance between work and personal life, recognizing the importance of employee well-being.</li><br>
  <li><strong>Seek Feedback and Act Upon It:</strong> Regularly solicit employee feedback and use it to drive positive change within the organization.</li>
</ol>
<p>Employee engagement is not a destination but an ongoing journey, requiring consistent effort and dedication from leadership. It's an investment in the human capital that drives the engine of business success.</p>
<p>In closing, business leaders must recognize that employee engagement is not a mere HR initiative but a fundamental pillar of organizational excellence. It's the driving force behind a thriving workplace, where individuals feel valued, empowered, and inspired to contribute their best. By prioritizing employee engagement, organizations not only reap the rewards of enhanced productivity and financial performance but also cultivate a legacy of human connection, innovation, and sustainable success.</p>`,

    },
    {
      id: 5,
      title: 'Building Amazing Communities of Leaders in the Digital Age: A Guide for Thriving in Today\'s Landscape',
      date: '29 Jan, 2025',
      readTime: '5 Min Read',
      image: Article5Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>Building Amazing Communities of Leaders in the Digital Age: A Guide for Thriving in Today's Landscape</h2>

<p>Forget the corner office, it's time for the leadership circle.  In a world where work is more connected than ever, building communities of diverse, empowered leaders is the key to success.  This blog dives deep, offering insights from 2,000+ leaders on how to unlock your team's full potential. Discover the mindsets and skills needed to navigate the digital age and build a thriving leadership ecosystem.  Ready to unleash your inner leader? Read on!</p>

<h3>The Challenges of Leading in the Digital Age:</h3>
<ul>
  <li><strong>Outdated Mindsets:</strong> Leaders still clinging to old-world thinking struggle to adapt to rapid technological advancements and evolving customer expectations.</li><br>
  <li><strong>Blind Spots:</strong> Unconscious biases and cultural norms can hinder progress and limit the ability to attract and retain diverse talent.</li><br>
  <li><strong>Lack of Collaboration:</strong> Siloed structures and communication gaps impede the flow of ideas and hinder innovation.</li><br>
  <li><strong>Disengagement and Lack of Purpose:</strong> Employees yearning for meaning and connection can become disengaged, leading to decreased productivity and satisfaction.</li>
</ul>
<h3>The 4 Pillars of Amazing Communities of Leaders:</h3>
<ol>
  <li><strong>Creator Mindset:</strong> Cultivate a focus on customer-centricity, data-driven decision-making, and agile execution.</li><br>
  <li><strong>Investor Mindset:</strong> Pursue a higher purpose beyond profits, prioritizing sustainability, community impact, and employee well-being.</li><br>
  <li><strong>Collaborator Mindset:</strong> Foster strong relationships, partnerships, and networks to leverage diverse perspectives and achieve shared goals.</li><br>
  <li><strong>Explorer Mindset:</strong> Embrace curiosity, creativity, and a willingness to experiment in the face of uncertainty.</li>
</ol>


<h3>Building the Foundation:</h3>
<ul>
  <li><strong>Articulate a Powerful Leadership Narrative:</strong> Clearly define your vision for leadership in the digital age and the values that guide it.</li><br>
  <li><strong>Identify Future Leaders Early:</strong> Look for individuals who embody the desired mindsets and behaviors across all levels of your organization.</li><br>
  <li><strong>Empower All Employees:</strong> Create a culture of transparency, trust, and open communication where everyone feels valued and capable of contributing.</li><br>
  <li><strong>Align Talent, Leadership, and Business Strategies:</strong> Ensure your talent acquisition, development, and promotion practices are aligned with your leadership needs.</li><br>
  <li><strong>Embrace and Demand Diversity and Inclusion:</strong> Go beyond lip service and actively cultivate a diverse and inclusive workplace where everyone feels welcome and empowered.</li>
</ul>
<h3>The Future of Leadership:</h3>
<p>The future belongs to leaders who are courageous, adaptable, and purpose-driven. They are the ones who can build thriving communities of leaders, unleashing the collective potential of their organizations to create a better world.</p>
<p>Ready to take the first step? Start by reflecting on your leadership approach and the culture you are fostering. Then, explore the resources and recommendations provided here to begin building your amazing community of leaders.</p>
<p>Creating a thriving community is an ongoing journey, not a destination. Embrace the challenges, celebrate the successes, and keep leading with courage, purpose, and joy!</p>
<p>This blog post is just a starting point. Share your thoughts and experiences in the comments below. Let's continue the conversation about building amazing communities of leaders together!</p>
<p><strong>Sources -</strong></p>
      <p><a href="https://www.peoplematters.in/article/leadership-development/how-can-you-make-your-organisation-an-amazing-community-of-leaders-31962"
      target="_blank" rel="noopener noreferrer">
      https://www.peoplematters.in/article/leadership-development/how-can-you-make-your-organisation-an-amazing-community-of-leaders-31962
      </a></p>
`
      ,

    },
    {
      id: 6,
      title: 'Beyond Talent: Unraveling the Enigma of Professional Success',
      date: '22 Jan, 2025',
      readTime: '5 Min Read',
      image: Article7Image,
      author: { name: 'Robbin S', avatar: Article4Image },
      content: `<h2>Beyond Talent: Unraveling the Enigma of Professional Success</h2>
<p>In a world that celebrates talent and hard work, why do some individuals still find success elusive? This blog explores the nuanced factors that contribute to professional success, delving into the realm beyond skills and diligence. Let's embark on a journey to uncover the hidden dimensions that shape a truly successful career.</p>
<h3>The Myth of Meritocracy:</h3>
<p>Success is often portrayed as a direct result of talent and hard work. However, the reality is more complex. Unravel the myth of meritocracy and understand how factors like networking, timing, and opportunities play pivotal roles.</p>
<h3>Embracing Failure as a Stepping Stone:</h3>
<p>Success and failure are intertwined. Explore the stories of accomplished individuals who faced setbacks before reaching their pinnacle. Learn how resilience, adaptability, and a growth mindset can turn failures into stepping stones toward success.</p>
<h3>The Power of Emotional Intelligence:</h3>
<p>Beyond technical skills, emotional intelligence is a game-changer. Understand how empathy, self-awareness, and effective communication contribute to building strong professional relationships and opening doors to new opportunities.</p>
<h3>Navigating the Corporate Landscape:</h3>
<p>Climbing the corporate ladder requires more than just hard work. Decode the unwritten rules of office politics, effective communication, and strategic positioning to ensure your efforts are recognized and rewarded.</p>
<h3>Investing in Continuous Learning:</h3>
<p>The professional landscape is ever-evolving. Stay ahead by embracing a mindset of continuous learning. Explore how acquiring new skills and adapting to industry trends can set you apart in a competitive environment.</p>

<h3>Building a Personal Brand:</h3>
<p>In a world crowded with talent, standing out is crucial. Delve into the concept of personal branding and understand how showcasing your unique strengths and values can elevate your professional profile.</p>
<h3>Cultivating a Growth Mindset:</h3>
<p>Success is not a destination but a journey. Cultivate a growth mindset that thrives on challenges and sees effort as a path to mastery. Discover how this mindset fosters resilience and propels you toward continuous improvement.</p>
<p>In the quest for professional success, talent and hard work are essential, but they're just the beginning. This blog aims to spark introspection and guide you toward a holistic approach that encompasses the often-overlooked elements contributing to a truly successful and fulfilling career. Are you ready to redefine your path to success? Let's embark on this transformative journey together.</p>

`

      ,

    },
    {
      id: 7,
      title: 'The Looming Shadow: Navigating Layoffs with Humanity and Hope',
      date: '15 jan, 2025',
      readTime: '6 Min Read',
      image: ArticleImage2,
      author: { name: 'John Doe', avatar: ArticleImage4 },
      content: `<h2>The Looming Shadow: Navigating Layoffs with Humanity and Hope</h2>
    <p>The storm clouds of economic uncertainty gather, and their first drops are felt in the form of rising layoff numbers. A staggering 40% of companies anticipate shedding jobs in 2024, a grim statistic that sends shivers down the spines of both employers and employees. While cost-cutting might seem like the logical answer, the human cost of layoffs can be immense, impacting individuals, families, and even the companies themselves.</p>
    <p>But amidst the gloom, there's a glimmer of hope. By prioritizing transparency, compassion, and support, we can navigate this turbulent period with a semblance of grace. Here's a compass to guide us through the choppy waters:</p>
    <p><strong>Honesty, the Best Policy:</strong> Shrouding layoffs in secrecy breeds fear and resentment. Be upfront about the "why" behind the cuts, explaining the rationale objectively and clearly. Remember, even bad news delivered honestly is easier to swallow than shrouded uncertainty.</p>
    <p><strong>Beyond the Severance Package:</strong> A hefty severance package might ease the immediate financial burden, but true support goes beyond the paycheck. Offer resources like career counseling, resume workshops, and connections to potential employers. Empowering individuals to land on their feet fosters goodwill and reflects positively on your company.</p>
    <p><strong>The Long Goodbye:</strong> Consider a more humane approach - the "long goodbye." This extended period allows departing employees to share knowledge, transition smoothly, and secure new opportunities while still drawing a paycheck. It's a win-win, demonstrating compassion and minimizing disruption.</p>
    <p><strong>Building Bridges, Not Walls:</strong> Don't sever ties with departing employees. Stay connected! Periodic check-ins, job leads, and updates on company developments show you care and keep the network alive. These individuals might boomerang back someday, bringing valuable experience and renewed loyalty.</p>
    <p><strong>Mind the Survivors:</strong> The burden doesn't solely fall on those leaving. "Survivor's guilt" and increased workload can weigh heavily on remaining employees. Open communication, regular check-ins, and readily available resources like Employee Assistance Programs are crucial to navigate this emotional rollercoaster.</p>
    <p><strong>Rethink, Reconsider:</strong> Before wielding the layoff axe, explore alternatives. Can hiring freezes, pay cuts, or temporary measures buy you time? Remember, layoffs often come at a hidden cost - reduced innovation, lower morale, and ultimately, hindered growth.</p>
    <p>Remember, layoffs are a complex issue with no easy answers. But by prioritizing humanity, transparency, and support, we can navigate this difficult terrain with a modicum of dignity and hope. Let's strive to create a future where economic realities don't overshadow our responsibility to each other, where job losses are met with empathy and a commitment to rebuild, together.</p>
    <p>Let's turn this looming shadow into an opportunity for growth, for learning, and for building a more resilient, humane workplace. It's a challenge, but together, we can weather the storm.</p>
    <p><strong>Source -</p></strong> <a href="https://www.hrmorning.com" target="_blank" rel="noopener noreferrer">
          www.hrmorning.com
          </a>
   
    `
    },
    {
      id: 8,
      title: 'Finding the Perfect Work-Life Balance with a Leader by Your Side 🚀',
      date: '8 Jan, 2025',
      readTime: '5 Min Read',
      image: ArticleImage3,
      author: { name: 'Sarah Johnson', avatar: ArticleImage4 },
      content: `<h2>Finding the Perfect Work-Life Balance with a Leader by Your Side 🚀</h2>
          <p>Let's talk about that ever-elusive goal we all chase after - WORK-LIFE BALANCE. It's like trying to juggle flaming torches while riding a unicycle on a tightrope - challenging but not impossible! The secret to achieving this mythical equilibrium lies in having a fantastic leader by your side. Today, we want to share some insights on how a great leader can help all of us find that sweet spot between career success and personal fulfillment.</p>
    <h3>Understanding the Priorities</h3>
    <p>A remarkable leader knows that employees are not just cogs in the corporate machine. They take the time to understand employees' priorities, values, and aspirations beyond the workplace. By recognizing the importance of one’s personal lives, they create an environment that encourages others to pursue their passions outside of work.</p>
    <h3>Flexible Work Arrangements</h3>
    <p>A leader worth their salt understands that the traditional 9-to-5 work schedule doesn't always fit into everyone's life puzzle. By embracing flexibility, a leader can offer remote work options, flexible hours, or compressed workweeks. This allows employees to attend to personal commitments and responsibilities without sacrificing their professional dedication.</p>
    <h3>Leading by Example</h3>
    <p>Leaders who practice what they preach are like beacons of inspiration. When they demonstrate a healthy work-life balance themselves, it sends a powerful message to the team. It encourages them to prioritize their well-being, reminding them that their productivity and creativity will flourish when they are mentally and physically refreshed.</p>
    <h3>Encouraging Time Off</h3>
    <p>Everyone needs a break from time to time, and a supportive leader understands the importance of taking time off to recharge. They actively encourage employees to use their vacation days, sick leaves, and mental health days when needed. They create an atmosphere where rest is valued and not stigmatized.
    </p>
    <h3>Promoting Well-being Initiatives</h3>
    <p>Incorporating well-being initiatives into the company culture shows that a leader genuinely cares about the team's health and happiness. Whether it's organizing yoga sessions, meditation workshops, or mental health seminars, these activities foster a positive work environment.</p>
    <h3>Open Communication</h3>
    <p>Effective leaders are approachable and receptive to feedback. They create an open-door policy, making it easier for employees to discuss their work-life balance concerns without fear of judgment. Open communication ensures that everyone's needs are heard and addressed.</p>
    <h3>Celebrating Milestones, Big and Small</h3>
    <p>A leader who acknowledges both professional and personal milestones makes the journey worthwhile. Whether it's congratulating an employee on a job well done or celebrating birthdays, anniversaries, or other life events, this recognition fosters a sense of belonging and appreciation.</p>
    <p>In conclusion, finding the perfect work-life balance is a team effort, and a supportive leader is a crucial part of that equation. By prioritizing employee well-being, offering flexibility, and encouraging open communication, you can empower your team to lead happier, more fulfilling lives inside and outside the workplace.</p>
    <p>So, let's raise a virtual toast to all the amazing leaders out there who champion work-life balance and help us master the art of juggling work and play! 🥂</p>
    <p>#WorkLifeBalance #LeadershipMatters #LifeHacks #EmployeeWellbeing</p>
          `
    },
    {
      id: 9,
      title: '🚀Workplace Predictions for 2024: Navigating the Future of Work! 🌐',
      date: '1 Jan, 2025',
      readTime: '7 Min Read',
      image: ArticleImage4,
      author: { name: 'Michael Lee', avatar: ArticleImage4 },
      content: `<h2>🚀Workplace Predictions for 2024: Navigating the Future of Work! 🌐</h2>
          <p>Nine groundbreaking workplace predictions, providing a roadmap for CHROs to steer their organizations through the evolving landscape of talent acquisition and retention in 2024 and beyond.</p>
          <h3>1. Cost-of-Work Crisis Reaches a Breaking Point</h3>
          <p>As remote work becomes the norm, employees keenly feel the costs associated with returning to the office. In response, organizations are set to address this crisis by sharing tangible and intangible costs, introducing benefits like caregiving support, housing subsidies, and more.</p>
          <h3>2. AI Creates Workforce Opportunity</h3>
          <p>Contrary to fears, Generative AI (GenAI) is predicted to create opportunities by enhancing roles, lowering technical skill requirements, and reshaping hiring strategies. HR leaders are urged to assess GenAI's impact on team roles and workflows.</p>
          <h3>3. Four-Day Workweeks Go from Radical to Routine</h3>
          <p>Embracing a four-day workweek (4DWW) gains traction as organizations reevaluate the workweek cadence to enhance employee engagement, performance, and overall well-being. The 4DWW model is positioned as a strategic tool to improve talent outcomes and drive business efficiency. The Indian state of Kerala became the first in the country to officially implement a 4DWW model for government employees in September 2023. While it's still early days, initial reports suggest promising trends:</p>
         <ul>
      <li><strong>Employee Morale:</strong> Increased employee engagement and reduced stress levels have been observed.</li><br>
      <li><strong>Work-Life Balance:</strong> Employees report having more time for family, hobbies, and personal development.</li><br>
      <li><strong>Government Efficiency:</strong> There are indications of improved productivity and streamlined processes.</li>
    </ul>
    <h3>4. Employee Conflict Resolution is a Must-Have Skill</h3>
          <p>With global crises on the rise, employee conflicts are expected to peak in 2024. Effective conflict resolution becomes a critical skill for managers to maintain organizational harmony. Training programs and recognition mechanisms are recommended to equip and appreciate conflict resolution skills.</p>
          <h3>5. Generative AI Experiments Yield Lessons and Costs</h3>
          <p>While excitement surrounds GenAI, organizations must actively manage risks, including stricter access policies and quality control. The focus is on training employees to exercise judgment in using GenAI tools, balancing potential benefits with potential pitfalls.</p>
          <h3>6. Skills Overtake Degrees as the Paper Ceiling Crumbles</h3>
          <p>Organizations are breaking away from traditional degree-centric hiring, and embracing skills-based recruitment. This shift opens doors to a broader talent pool and emphasizes the importance of skills over degrees in the evolving job market.</p>
          <h3>7. Climate Change Protection Becomes a New Employee Benefit</h3>
          <p>As climate-related events become more widespread, organizations prioritize climate change protection in their benefits packages. Commitments to physical safety, compensation, and mental health support during disasters emerge as key offerings.</p>
          <h3>8. DEI Embeds Itself in Organizational Culture</h3>
          <p>Diversity, Equity, and Inclusion (DEI) transition from standalone initiatives to integral parts of organizational culture. The focus is on integrating DEI values into daily operations, business objectives, and corporate ethos.</p>
          <h3>9. Career Stereotypes Collapse in the Face of Workforce Change</h3>
          <p>Traditional career paths dissolve as atypical career trajectories become mainstream. Employers break free from talent stereotypes, offering flexible work arrangements, gig opportunities, and recognizing expertise beyond conventional career progressions.</p>
          <p🌟 These predictions underscore the dynamic nature of the modern workplace, urging HR leaders to proactively address these trends for a resilient and adaptive workforce in 2024. </p>
          <p>#FutureOfWork #GartnerPredicts #WorkplaceInnovation 🌐👩‍💼🚀</p>
    <p><strong>Source -</p>
    </strong> <a href="https://www.communicationstoday.co.in/gartner-unveils-top-9-workplace-predictions-for-hr-leaders-in-2024/" target="_blank" rel="noopener noreferrer">
          https://www.communicationstoday.co.in/gartner-unveils-top-9-workplace-predictions-for-hr-leaders-in-2024/
          </a>
          `
    },
  ];

  const handleTrendingClick = (title) => {
    const selectedArticle = articles.find((article) => article.title === title);
    if (selectedArticle) {
      sessionStorage.setItem("articleData", JSON.stringify(selectedArticle));
      sessionStorage.removeItem("scrollPosition");
      sessionStorage.removeItem("initialScrollPosition");
      window.location.href = "/blogdetails";
    }
  };

  // Data for candidate count chart
  const viewedCount = useMemo(() => _.get(dashboardData, 'activeSubscription.viewedCount', 0), [dashboardData]);
  const remainingViews = useMemo(() => _.get(dashboardData, 'activeSubscription.remainingViews', 0), [dashboardData]);
  const totalViews = useMemo(() => viewedCount + remainingViews, [viewedCount, remainingViews]);
  const candidateCountData = useMemo(() => ({
    labels: ['Viewed', 'Remaining'],
    datasets: [
      {
        data: [viewedCount, remainingViews],
        backgroundColor: ['#1c8eb4', '#294cb5'],
        hoverBackgroundColor: ['#1c8eb4', '#294cb5'],
      },
    ],
  }), [viewedCount, remainingViews]);

  // Funnel chart data for shortlistedPercentageByStatus
  const statusColorMapping = {
    SHORTLISTED: '#F9AE1A',
    HIRED: '#4265CC',
    ON_HOLD: '#9EDB6B',
    REJECTED: '#8D26B9',
    INTERVIEWED: '#EF5D28',
  };

  const shortlistedPercentageByStatus = useMemo(() => {
    return roundDataValues(
      isDateSelected
        ? _.get(shortlistAnalytics, 'shortlistedPercentageByStatus', {})
        : _.get(dashboardData, 'shortlistedPercentageByStatus', {})
    ) || {};
  }, [dashboardData, shortlistAnalytics, isDateSelected]);

  const funnelData = useMemo(() => {
    return Object.keys(shortlistedPercentageByStatus).map((status) => ({
      label: status,
      value: shortlistedPercentageByStatus[status],
      color: statusColorMapping[status],
    }));
  }, [shortlistedPercentageByStatus]);

  // Data for shortlistedPercentageByGender
  const genderColorMapping = {
    female: '#EF5D28',
    male: '#F9CD1A',
    null: '#FFE29A',
  };

  const shortlistedPercentageByGender = useMemo(() => {
    return roundDataValues(
      isDateSelected
        ? _.get(shortlistAnalytics, 'shortlistedPercentageByGender', {})
        : _.get(dashboardData, 'shortlistedPercentageByGender', {})
    ) || {};
  }, [dashboardData, shortlistAnalytics, isDateSelected]);

  const totalPercentage = Object.values(shortlistedPercentageByGender).reduce((acc, value) => acc + value, 0);

  const genderData = useMemo(() => ({
    labels: Object.keys(shortlistedPercentageByGender),
    datasets: [
      {
        data: Object.values(shortlistedPercentageByGender),
        backgroundColor: Object.keys(shortlistedPercentageByGender).map(
          (gender) => genderColorMapping[gender.toLowerCase()]
        ),
        hoverBackgroundColor: Object.keys(shortlistedPercentageByGender).map(
          (gender) => genderColorMapping[gender.toLowerCase()]
        ),
      },
    ],
  }), [shortlistedPercentageByGender]);


  const functionColorMap = {
    Director: '#F57400',
    CFO: '#294CB5',
    CEO: '#F59C00',
    Others: '#1C8EB4',
    'Senior Manager': '#F9CD1A',
  };

  const shortlistedByFunction = useMemo(() => {
    return roundDataValues(
      _.get(dashboardData, 'shortlistedByFunction', {})
    ) || {};
  }, [dashboardData]);
  const functionData = useMemo(() => ({
    labels: Object.keys(shortlistedByFunction),
    datasets: [
      {
        data: Object.values(shortlistedByFunction),
        backgroundColor: Object.keys(shortlistedByFunction).map(
          (func) => functionColorMap[func]
        ),
        hoverBackgroundColor: Object.keys(shortlistedByFunction).map(
          (func) => functionColorMap[func]
        ),
      },
    ],
  }), [shortlistedByFunction]);

  const shortlistedPercentageByCtc = useMemo(() => {
    return isDateSelected
      ? _.get(shortlistAnalytics, 'shortlistedPercentageByCtc', {})
      : _.get(dashboardData, 'shortlistedPercentageByCtc', {});
  }, [dashboardData, shortlistAnalytics, isDateSelected]);

  const ctcData = useMemo(() => ({
    labels: Object.keys(shortlistedPercentageByCtc || {}),
    datasets: [
      {
        data: Object.values(shortlistedPercentageByCtc || {}),
        backgroundColor: generateContrastingColors(Object.keys(shortlistedPercentageByCtc || {}).length),
      },
    ],
  }), [shortlistedPercentageByCtc]);
  const [activeToggle, setActiveToggle] = useState('designation');
  const handleToggleClick = (toggle) => {
    setActiveToggle(toggle);
  };


  useEffect(() => {
    if (dashboardData?.recentViewsResponse?.recentViews?.length > 0) {
      setIsRecentSearchLoading(true);
      const extractedClients = dashboardData.recentViewsResponse.recentViews.map(search => ({
        designation: search.designation,
        industry: search.industry,
        totalExperience: search.totalExperience,
        location: search.location
      }));
      setRecentClients(extractedClients);
      setIsRecentSearchLoading(false);
    } else {
      setRecentClients([]);
    }
  }, [dashboardData]);

  // Fetch totalProfiles and newProfiles from candidateAnalytics
  const totalProfiles = useMemo(() => _.get(dashboardData, 'candidateAnalytics.totalProfiles', 0), [dashboardData]);
  const newProfiles = useMemo(() => _.get(dashboardData, 'candidateAnalytics.newProfiles', 0), [dashboardData]);
  const candidateCount = useMemo(() => ({
    labels: ['Existing Profile', 'New Profile Added'],
    datasets: [
      {
        data: [totalProfiles, newProfiles],
        backgroundColor: ['#F8C400', '#DB0000'],
        hoverBackgroundColor: ['#F8C400', '#DB0000'],
      },
    ],
  }), [totalProfiles, newProfiles]);

  // Fetch salaryRangeData from candidateAnalytics
  const salaryRangeData = useMemo(() => _.get(dashboardData, 'candidateAnalytics.countBySalaryRange', {}), [dashboardData]);
  const countsalaryRangeData = useMemo(() => {
    const backgroundColors = generateContrastingColors(_.keys(salaryRangeData).length);
    return {
      labels: _.keys(salaryRangeData),
      datasets: [
        {
          data: _.values(salaryRangeData),
          backgroundColor: backgroundColors,
          hoverBackgroundColor: [...backgroundColors],
        },
      ],
    };
  }, [salaryRangeData]);

  const designationData = {};
  const countdesignationData = {};

  const genderCounts = useMemo(() => ({
    male: _.get(dashboardData, 'candidateAnalytics.countByGender.MALE', 0),
    female: _.get(dashboardData, 'candidateAnalytics.countByGender.FEMALE', 0),
    other: _.get(dashboardData, 'candidateAnalytics.countByGender.DONT_WANT_TO_SPECIFY', 0),
  }), [dashboardData]);

  const totalGenderCount = useMemo(() => genderCounts.male + genderCounts.female + genderCounts.other, [genderCounts]);
  const countgenderData = useMemo(() => {
    const malePercentage = totalGenderCount ? Math.round((genderCounts.male / totalGenderCount) * 100) : 0;
    const femalePercentage = totalGenderCount ? Math.round((genderCounts.female / totalGenderCount) * 100) : 0;
    const otherPercentage = totalGenderCount ? Math.round((genderCounts.other / totalGenderCount) * 100) : 0;

    return {
      labels: ['Male', 'Female', 'Other'],
      datasets: [
        {
          data: [malePercentage, femalePercentage, otherPercentage],
          backgroundColor: ['#37B38B', '#1E96BE', '#FF6384'],
          hoverBackgroundColor: ['#37B38B', '#1E96BE', '#FF6384'],
        },
      ],
    };
  }, [genderCounts, totalGenderCount]);
  const overallTotalPercentage = totalGenderCount ? Math.round((totalGenderCount / totalGenderCount) * 100) : 0;

  const fetchTotalShortlistedCount = async () => {
    try {
      const firstResponse = await ClientService.getShortlistedCandidates(null, 0, size);
      if (!firstResponse) return;

      let totalShortlisted = firstResponse.shortlists?.filter(candidate => candidate.shortlistStatus === 'SHORTLISTED').length || 0;

      if (totalShortlisted > 0) {
        setShortlistedCount(totalShortlisted);
        localStorage.setItem("shortlistedCount", totalShortlisted);
      }

      let pageNo = 1;
      let hasNextPage = firstResponse.hasNext;

      while (hasNextPage) {
        const response = await ClientService.getShortlistedCandidates(null, pageNo, size);
        if (response && response.shortlists) {
          totalShortlisted += response.shortlists.filter(candidate => candidate.shortlistStatus === 'SHORTLISTED').length;
        }
        hasNextPage = response.hasNext;
        pageNo += 1;
      }

      if (totalShortlisted !== shortlistedCount) {
        setShortlistedCount(totalShortlisted);
        localStorage.setItem("shortlistedCount", totalShortlisted);
      }
    } catch (error) {
      console.error("Error fetching total shortlisted count:", error);
    }
  };

  const [shortlistedCount, setShortlistedCount] = useState(() => {
    return localStorage.getItem("shortlistedCount") || 0;
  });

  const renderShortlistedCount = shortlistedCount;

  const fetchShortlistedCandidates = async (pageNo = 0) => {
    setIsShortlistLoading(true);
    try {
      const response = await ClientService.getShortlistedCandidates(null, pageNo, size);

      setShortlistedCandidates(response.shortlists || []);
      setHasNext(response.hasNext);
      setPage(response.page || pageNo);
      setTotalPages(response.totalPages);
    } finally {
      setIsShortlistLoading(false);
    }
  };

  useEffect(() => {
    if (!clientId) return;

    if (restoredState.current) {
      return;
    }

    fetchTotalShortlistedCount();
    fetchShortlistedCandidates(0);
  }, [clientId]);





  // Pagination control functions
  const goToFirstPage = () => fetchShortlistedCandidates(0);
  const goToPreviousPage = () => fetchShortlistedCandidates(Math.max(0, page - 1));
  const goToNextPage = () => {
    if (hasNext) {
      fetchShortlistedCandidates(page + 1);
    }
  };
  const goToLastPage = () => {
    if (totalPages > 1) {
      fetchShortlistedCandidates(totalPages - 1);
    }
  };


  //Fetch profile image
  useEffect(() => {
    const fetchImageUrls = async () => {
      const urls = await Promise.allSettled(
        shortlistedCandidates.map(async (item) => {
          const displayPicPath = _.get(item, 'candidate.candidate.personalDetails.displayPic[0].path', null);
          if (displayPicPath) {
            return axios
              .get(`https://${serverConfig.serverBaseAddress}/signite/file/download?path=${displayPicPath}`, {
                headers: CandidateService.getAuthHeader(),
                responseType: 'blob',
              })
              .then((response) => {
                const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
                return URL.createObjectURL(imageBlob);
              })
              .catch((err) => {
                return null;
              });
          }
        })
      ).then((results) => {
        const imageBlobs = [];
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            imageBlobs.push(result.value);
          } else {
            imageBlobs.push(null);
          }
        });
        setImageUrls(imageBlobs);
      });
    };
    if (shortlistedCandidates.length > 0) {
      fetchImageUrls();
    }
  }, [shortlistedCandidates]);
  const handleSearchResult = () => {
    navigate('/client/candidate-search-result');
  };



  return (
    <div className="client-dashboard-container-fluid">
      <div className='client-dashboard-button'>

      </div>
      <div className="client-dashboard-title">
        <div className="dashboard-searchbar-container">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            className="dashboard-searchbar-input"
            placeholder="Search Function etc."
            onFocus={handleSearchResult}
          // onFocus={onSearchFocus}
          />
          {/* <button className="search-button" onClick={onSearchFocus}> */}
          <button className="search-button" onClick={handleSearchResult} style={{ fontSize: '16px' }}>
            Search
          </button>
        </div>
        <div className="client-month-selector">
          <DatePicker
            selected={isDateSelected ? selectedDate : null}
            onChange={onDateChange}
            dateFormat="yyyy/MM"
            showMonthYearPicker
            maxDate={new Date()}
            customInput={<CustomInput value={isDateSelected && selectedDate ? selectedDate.toLocaleDateString("en-GB", { year: 'numeric', month: '2-digit' }) : ""} />}
          />
        </div>


      </div>
      {/* Cards displaying various statistics */}
      <div className="client-card-container row">
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <h3>Candidate Count As Per Subscription</h3>
          <DoughnutChart
            data={candidateCountData}
            chartType="subscription"
            centerData={totalViews}
            centerText="Candidates"
          />
        </div>
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <Subscription activeSubscription={_.get(dashboardData, 'activeSubscription')} />
        </div>
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <h3>Recruitment Funnel</h3>
          <FunnelChartComponent data={funnelData} />
        </div>
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <div className="client-dashboard-card-header">
            <h3>Shortlisted Candidates By Function</h3>
            {/* <div className="client-toggle-container">
              <button
                className={`client-designation-toggle ${activeToggle === 'designation' ? 'active' : ''}`}
                onClick={() => handleToggleClick('designation')}
              >
                Designation
              </button>
              <button
                className={`client-worktype-toggle ${activeToggle === 'worktype' ? 'active' : ''}`}
                onClick={() => handleToggleClick('worktype')}
                type="button"
              >
                Work Type
              </button>
            </div> */}
          </div>
          <DoughnutChart
            data={functionData}
            chartType="countdesignation"
            centerText="Total"
            centerData="100 %"
          />
        </div>
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <h3>Shortlisted Candidates By Gender</h3>
          <DoughnutChart
            data={genderData}
            chartType="gender"
            centerData={parseFloat(totalPercentage).toFixed(2) + '%'}
            centerText="Total"
          />
        </div>
        <div className="client-dashboard-card col-md-6 col-lg-4 mb-4">
          <h3>Shortlisted Candidates CTC</h3>
          <PieChart data={ctcData} chartType="piechart" />
        </div>
      </div>

      {/* Recent Search section */}
      <div className="client-card-section">
        <div className="client-recent-search-card">
          <div className="client-recentsearch-view-container">
            <h3>
              Recent Search <span className="client-item-count">({recentClients.length})</span>
            </h3>
            {/* <a href="/shortlist-view-more" className="client-shortlist-view-more">
              View More
            </a> */}
          </div>
          <div className="client-table-wrapper">
            {/* {isRecentSearchLoading ? (
              <div className="overlay-spinner">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading recent searches...</span>
                </Spinner>
              </div>
            ) : ( */}
            <table className="client-table">
              <thead>
                <tr>

                  <th>
                    Function
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    Industry
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    Experience
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    Location
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {recentClients.length > 0 ? (
                  recentClients.map((clientsearch, index) => (
                    <tr key={index}>
                      <td>{clientsearch.designation}</td>
                      <td>{clientsearch.industry}</td>
                      <td>{clientsearch.totalExperience ? `${clientsearch.totalExperience} years` : ""}</td>
                      <td>{clientsearch.location}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {/* <td colSpan="3" className="no-data-placeholder" style={{ height: "240px", textAlign: "center", verticalAlign: "middle" }}>
                      No data available yet
                    </td> */}
                  </tr>
                )}
              </tbody>
            </table>
            {isRecentSearchLoading && (
              <div className="overlay-spinner">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            )}

          </div>
        </div>
        {/* Shortlisted candidates section */}
        <div className="client-shortlisted-candidates-card">
          <div className="client-shortlist-view-container">
            <h3>
              Shortlisted Candidates{' '}
              <span className="client-item-count">
                ({dashboardData?.shortlistsResp?.totalCount ?? 0})
              </span>
            </h3>
          </div>

          <div className="client-table-wrapper">
            {/* {isShortlistLoading ? (
              <div className="overlay-spinner">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading shortlisted candidates...</span>
                </Spinner>
              </div>
            ) : ( */}
            <table className="client-shortlist-table">
              <thead>
                <tr>
                  <th>
                    Name
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    Experience
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    CTC
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="client-recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="client-recent-filters" />
                  </th>
                  <th>
                    Status
                    <img src={ClientSortRecentFilter} alt="Name Icon" className="recent-filters" />
                    <img src={ClientRecentFilter} alt="Name Icon" className="recent-filters" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {shortlistedCandidates.length > 0 ? (
                  shortlistedCandidates.map((item, index) => {
                    const candidateData = item.candidate?.candidate || {};
                    const status =
                      item.currentStatus ||
                      item.shortlistHistory?.shortlistHistoryNodes?.find(n => n.active)?.shortlistStatus ||
                      ''; const personalDetails = candidateData.personalDetails || {};
                    const firstName = (personalDetails.firstName || '').trim();
                    const middleName = (personalDetails.middleName || '').trim();
                    const lastName = (personalDetails.lastName || '').trim();
                    const candidateName =
                      `${firstName} ${middleName} ${lastName}`.trim() || '';
                    const workExperience = candidateData.workExperience || {};
                    const totalYears = workExperience.totalYrs || 0;
                    const workMonths = workExperience.workExMonths || 0;
                    const candidateExperience =
                      totalYears > 0 || workMonths > 0
                        ? `${totalYears} years ${workMonths} months`
                        : '';

                    const compensationDetails = candidateData.compensationDetails || {};
                    const totalCtc = compensationDetails.total || 0;
                    const formattedCtc =
                      totalCtc > 0 ? `${totalCtc.toLocaleString()} L/annum` : '';

                    const imageUrl = imageUrls[index] || default_profile_image;

                    const lastUpdated = item.lastUpdated
                      ? new Date(item.lastUpdated).toLocaleString('en-US', {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                      })
                      : '';


                    return (
                      <tr key={index}>
                        <td className="client-candidate-profile">
                          <img
                            src={imageUrl}
                            alt={candidateName}
                            className="client-candidate-img"
                          />
                          <div className="client-candidate-name">
                            {candidateName}
                          </div>
                        </td>
                        <td>{candidateExperience}</td>
                        <td>{formattedCtc}</td>
                        <td>
                          <button
                            onClick={() => {
                              sessionStorage.setItem(
                                'dashboard_shortlist_state',
                                JSON.stringify({
                                  shortlistedCandidates,
                                  page,
                                  hasNext,
                                  totalPages,
                                })
                              );

                              navigate(
                                `/client/candidate-information?candidateId=${item.candidate?.candidateId}`,
                                {
                                  state: {
                                    from: 'dashboard',
                                    page,
                                    scrollY: window.scrollY,
                                  },
                                }
                              );
                            }}
                            style={{
                              backgroundColor: '#f35824',
                              color: '#FFFFFF',
                              border: '1px solid #f35824',
                              padding: '8px 16px',
                              borderRadius: '100px',
                              cursor: 'pointer',
                              fontWeight: 500,
                            }}
                          >
                            View Status
                          </button>
                        </td>


                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    {/* <td colSpan="4" className="no-data-placeholder" style={{ height: "240px", textAlign: "center", verticalAlign: "middle" }}>
                      No data available yet
                    </td> */}
                  </tr>
                )}
              </tbody>
            </table>
            {isShortlistLoading && (
              <div className="overlay-spinner">
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            )}

          </div>
          {shortlistedCandidates.length > 0 && totalPages > 1 && (
            <div className=" justify-center items-center text-center flex  p-1  rounded-lg shadow-md">
              <button
                onClick={goToFirstPage}
                disabled={page === 0 || isLoading}
                className={`pagination-button large-symbol ${page === 0 || isLoading ? ' cursor-not-allowed' : ''}`}
              >
                &laquo;
              </button>

              <button
                onClick={goToPreviousPage}
                disabled={page === 0 || isLoading}
                className={`pagination-button large-symbol ${page === 0 || isLoading ? ' cursor-not-allowed' : ''}`}
              >
                &lsaquo;
              </button>

              <span className="pagination-text px-4">
                {page + 1} of {totalPages || 1}
              </span>
              <button
                onClick={goToNextPage}
                disabled={!hasNext || isLoading}
                className={`pagination-button large-symbol ${!hasNext || isLoading ? ' cursor-not-allowed' : ''}`}
              >
                &rsaquo;
              </button>
              <button
                onClick={goToLastPage}
                disabled={page === totalPages - 1 || totalPages <= 1 || isLoading}
                className={`pagination-button large-symbol ${page === totalPages - 1 || totalPages <= 1 || isLoading ? ' cursor-not-allowed' : ''}`}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>

      </div>
      {/* Signite Notice Board */}
      {/* <div className="client-notice-board-card">
        <div className="client-notice-header-container">
          <h3>Leaderly Notice Board</h3>
          <a href="/all-notices" className="client-view-all">
            View All
          </a>
        </div>
        {notices.map((notice, index) => (
          <div className="client-notice-item" key={index}>
            <div className="client-notice-vertical-line"></div>
            <img src={client_notice_img} alt="Notice" className="client-notice-image" />
            <div className="client-notice-content">
              <div className="client-notice-text">
                <div className="client-notice-header">
                  <h4>{notice.title}</h4>
                  <div className="client-notice-time">
                    <img src={client_time_icon} alt="Client Time Icon" className="client-time-icon" />
                    <span>{notice.time}</span>
                  </div>
                </div>
                <p>{notice.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div> */}
      {/* Signite Strength section */}
      <div className="client-bottom-card-section">
        <Container>
          <Row className="client-bottom-card-head">
            <h3>Leaderly Strength</h3>
          </Row>
          <Row className="client-chart-row">
            <Col>
              <h5>Candidate Count</h5>
              <PieChart data={candidateCount} showTotalLabel={true} chartType="candidatecount" />
            </Col>
            <div className="client-red-dotted-line"></div>
            <Col>
              <h5>Count By Salary Range</h5>
              <PieChart data={countsalaryRangeData} />
            </Col>
            {/* <div className="client-red-dotted-line"></div>
            <Col>
              <h5>Count By Designation</h5>
              <DoughnutChart data={countdesignationData} chartType="designation" centerText="Total" centerData="20" />
            </Col> */}
            <div className="client-red-dotted-line"></div>
            <Col className="countByGenderDoughNutChartContainer" >
              <h5>Count By Gender</h5>
              <DoughnutChart
                data={countgenderData}
                chartType="countgender"
                centerData={overallTotalPercentage + '%'}
                centerText="Total"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="client-section-container">
        {/* Trending Topics */}
        <div className="client-trending-card-section">
          <div className="client-trending-card">
            <h3>Trending Topics</h3>
            <ul>
              {articles.map((article) => (
                <li key={article.id}>
                  <img src={Trending} alt="trending" className="client-trending" />
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleTrendingClick(article.title);
                    }}
                    className="trending-link"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}

            </ul>
          </div>
          {/* Trending Designations */}
          {/* <div className="client-trending-card">
            <h3>Trending Designations</h3>
            <ul>
              <li>
                <img src={Trending} alt="trending" className="client-trending" />
                <a href="#director-marketing">Director Marketing</a>
              </li>
              <li>
                <img src={Trending} alt="trending" className="client-trending" />
                <a href="#ceo">CEO</a>
              </li>
              <li>
                <img src={Trending} alt="trending" className="client-trending" />
                <a href="#coo">COO</a>
              </li>
              <li>
                <img src={Trending} alt="trending" className="client-trending" />
                <a href="#director-finance">Director Finance</a>
              </li>
              <li>
                <img src={Trending} alt="trending" className="client-trending" />
                <a href="#vice-president">Vice President</a>
              </li>
            </ul>
          </div> */}
        </div>
        {/* Candidate Location */}
        <div className="client-location-card-section">
          <div className="client-candidate-location-card">
            <h3>Candidate Location</h3>
            <div className="client-india-map-container">
              <div className="map-container">
                <IndiaMap className="client-india-map" />

                <div className="location-marker delhi">
                  <div className="percentage-circle red">36%</div>
                  <div class="line-container delhi-line red-line"></div>
                  <span>Delhi</span>
                </div>

                <div className="location-marker mumbai">
                  <div className="percentage-circle orange">80%</div>
                  <div class="line-container mumbai-line orange-line"></div>
                  <span>Mumbai</span>
                </div>

                <div className="location-marker hyderabad">
                  <div className="percentage-circle yellow">43%</div>
                  <div class="line-container hyderabad-line yellow-line"></div>
                  <span>Hyderabad</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;